/* eslint-disable */
export default function createCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  }
  var domain = window.location.hostname;
  domain =
    domain.match(/\./g) !== null && domain.match(/\./g).length > 1
      ? domain.substring(domain.indexOf("."))
      : "." + domain;

  document.cookie =
    name + "=" + value + expires + ";domain=" + domain + "; path=/";
}
